// extracted by mini-css-extract-plugin
export default {"infocontainer":"info_infocontainer__rd1mj","pricediv":"info_pricediv__AMBOr"};